<template>
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="明细记录-会员积分"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="list-box">
                <score-history-list />
            </div>
        </div>
    </div>
</template>

<script>
    import ScoreHistoryList from "@/model/Score/ScoreHistoryList";
    import RightTop from "@/model/RightTop";
    export default {
        name: "ScoreHistory",
        components: {RightTop, ScoreHistoryList},
        mounted: function () {
            this.$store.commit("setMenuId", "12-2");
        }
    }
</script>

<style scoped>
    .list-box{
        background-color: #ffffff;
        padding: 16px;
    }
</style>
